import { type ReactNode } from 'react'
import { Button, Popup } from '@quickmd-llc/design-system'

type Props = {
  title: string
  content: ReactNode
  onClosePopUp: () => void
  onSave: () => void
  isOpen: boolean
}

const MemberPagePopUp = ({ title, content, onClosePopUp, onSave, isOpen }: Props) => (
  <Popup
    isOpen={isOpen}
    onClose={onClosePopUp}
    lockOpen
    showCloseIcon
    styles={{ containerClassName: 'w-[925px] max-w-[925px]' }}
    header={{ title: <span className='text-2xl font-bold tracking-wide text-text-dark'>{title}</span> }}
    body={
      <div className='mt-sp-3 max-h-[calc(100vh-270px)] overflow-y-auto rounded border border-border-light p-sp-3'>
        {content}
      </div>
    }
    footer={
      <div className='mt-sp-3 flex justify-center'>
        <Button priority='primary' onClick={onSave} className='w-[446px]'>
          Save
        </Button>
      </div>
    }
  />
)

export default MemberPagePopUp
